import React from "react"

import FieldRAG_Icon from "../rag-icon"

export default function FieldRag_DropdownValueNotEmpty(props:any) {
    return (
        <React.Fragment>
            <div className={Classes("ui5-field-form-editable dropdown-form h-36", props.className)} onClick={props.onClick}>
                <FieldRAG_Icon className="fl-ac fl-no-shrink m-r-8" option={props.option}/>
                <div className="ui5-txt-default">{props.option.label}</div>
            </div>
            {props.children}
        </React.Fragment>
    )
}